import { useRef } from 'react';

import { useElementOnScreen } from '../../../hooks/useElementOnScreen';

import styles from './AboutCreatorCard.module.scss';

interface IAboutCreatorCardProps {
  imageUrl?: string;
  name?: string;
  position?: string;
  link?: string | null;
}

const AboutCreatorCard = ({ imageUrl, name, position, link = '#' }: IAboutCreatorCardProps) => {
  const containerRef = useRef<HTMLAnchorElement>(null);
  const onScreen = useElementOnScreen(containerRef, 0);

  return (
    <a
      ref={containerRef}
      href={link || ''}
      target="_blank"
      rel="noreferrer"
      className={`scale-in-hover ${styles['card']}`}
    >
      {onScreen && (
        <div className={styles['content']}>
          <div className={styles['photo-container']}>
            <img className={styles['photo']} src={imageUrl} alt={name} width="318" height="390" />
          </div>
          <div className={styles['information']}>
            <p className={styles['name']}>{name}</p>
            <p className={styles['position']}>{position}</p>
          </div>
        </div>
      )}
    </a>
  );
};

export default AboutCreatorCard;
